function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { Image } from "@custom/schema";
import React, { useMemo } from "react";
export default function EventSpeakers(props) {
    var speakersWithRowInfo = useMemo(function() {
        return props.speakers.map(function(speaker, index) {
            var rowIndex = Math.floor(index / 3); // calculate row index based on 3 items per row
            return _object_spread_props(_object_spread({}, speaker), {
                rowIndex: rowIndex
            });
        });
    }, [
        props.speakers
    ]);
    var rowsWithImage = useMemo(function() {
        // Explicitly declare the type of rowFlags
        var rowFlags = {};
        speakersWithRowInfo.forEach(function(speaker) {
            if (speaker.image) {
                rowFlags[speaker.rowIndex] = true; // mark this row as having an image
            }
        });
        return rowFlags;
    }, [
        speakersWithRowInfo
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "page-container my-12 md:mb-12 first:mt-0 lg:first:mt-0 lg:mt-20 last:mb-0 last:md:mb-4"
    }, props.speakerHeading && /*#__PURE__*/ React.createElement("h2", {
        className: "text-2xl md:text-3xl lg:text-4xl mb-9 md:mb-12"
    }, props.speakerHeading), /*#__PURE__*/ React.createElement("div", {
        className: "grid md:grid-cols-3 md:gap-x-6"
    }, speakersWithRowInfo.map(function(speaker, index) {
        return /*#__PURE__*/ React.createElement("div", {
            key: index,
            className: "mb-7 md:mb-9 lg:mb-10 font-heading flex flex-col"
        }, /*#__PURE__*/ React.createElement(EventSpeaker, {
            name: speaker.name,
            image: speaker.image,
            company: speaker.company,
            linkedinUrl: speaker.linkedinUrl,
            alignTop: !!rowsWithImage[speaker.rowIndex]
        }));
    })));
}
function EventSpeaker(param) {
    var company = param.company, name = param.name, linkedinUrl = param.linkedinUrl, image = param.image, alignTop = param.alignTop;
    var speakerStyle = alignTop ? "md:pt-[68px] lg:pt-[92px]" : "";
    return /*#__PURE__*/ React.createElement(React.Fragment, null, image ? /*#__PURE__*/ React.createElement("div", {
        className: "grow-0"
    }, /*#__PURE__*/ React.createElement(Image, {
        source: image.source,
        alt: image.alt,
        className: "w-14 lg:w-20 rounded-full shrink-0 overflow-hidden border-2 border-b-gray-400 mb-3"
    })) : /*#__PURE__*/ React.createElement("div", {
        className: "".concat(speakerStyle)
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "block md:text-lg lg:text-xl font-medium"
    }, name), /*#__PURE__*/ React.createElement("span", {
        className: "block text-sm lg:text-base"
    }, company), /*#__PURE__*/ React.createElement("div", {
        className: "inline-flex items-baseline gap-x-5"
    }, linkedinUrl && /*#__PURE__*/ React.createElement("a", {
        href: "".concat(linkedinUrl),
        className: "block mt-2"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "Linkedin"), /*#__PURE__*/ React.createElement("img", {
        src: "/images/Med.png",
        alt: "linkedin icon",
        className: "w-4 lg:w-[18px]"
    })))));
}
